<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-body>
    <div class="row full-height">
        <mojo-activity-table [selectedColumns]="selectedColumns$ | async" [activities]="activities$ | async"></mojo-activity-table>
    </div>
  </ng-container>
</mojo-widget>
